module.exports = __webpack_public_path__ + "img/sub-banner2.3b1896d7.jpg";